import { AfterViewInit, Directive, ElementRef, Injector, OnDestroy, OnInit } from "@angular/core";
import { FrameContext } from "@farris/devkit";
import { FarrisDatepickerComponent } from '@farris/ui-datepicker';
import { ComponentRef } from "./component-ref";

@Directive({
  selector: '[datepickerRef]'
})
export class DatepickerComponentRefDirective extends ComponentRef implements OnInit, OnDestroy, AfterViewInit {
  constructor(private injector: Injector, private component: FarrisDatepickerComponent, public elementRef: ElementRef, public frameContext: FrameContext) {
    super(frameContext, elementRef);
  }
  ngAfterViewInit(): void {
    this.tryAddComponent(this.component);
  }
  ngOnInit(): void {
    this.addComponent(this.component);
  }
  ngOnDestroy(): void {
  }

}